module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_03-09e4305e20c60758d09c699b8806058c.png";